import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Orders from './Orders'
import Graph from './Graph';
import IndividualLinks from './IndividualLinks';
import LinksCobro from './LinksCobro';
import MasiveLinks from './MasiveLinks';
import Resume from './Resume';
import { Box, Button, Chip, Typography } from '@material-ui/core';
import TxReports from './TxReports';


const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    border: 'none',
    boxShadow: "none"
  },
  fixedHeight: {
    height: 240,
  },
}));

export default function Home(props) {
  const [idempresa, setIdEmpresa] = useState(null);
  const [idusuario, setIdUsuario] = useState(null);
  const [id_commerce, setIdCommerce] = useState(null);
  const [nombreusuario, setNombreUsuario] = useState(null);
  const [token, setToken] = useState(null);
  useEffect(() => {

    // Aquí podrías hacer una llamada a la API para obtener datos iniciales
    
    setIdEmpresa(props.id_empresa);
    setIdUsuario(props.id_usuario);
    setNombreUsuario(props.nombre_usuario);
    setIdCommerce(props.id_commerce);
    setToken(props.token);
  }, [props.id_empresa, props.id_usuario, props.nombre_usuario, props.id_commerce, props.token]);

  let defrif = props.rif
  let defidEmpresa = props.id_empresa
  let defrazon = props.razon
  let deftoken = props.token
  let defnombre = props.nombre_usuario
  let defimg = props.img || ""
  let page = props.page
  let defidCommerce = props.id_commerce;
  const classes = useStyles();
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);


  return (


    <Grid container spacing={3}>

      {}
      {/* Transacciones */}
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          {/* { page === "home" ? <Orders rif={defrif} razon={defrazon} token={deftoken} /> : page === "charts" ? <Graph rif={defrif} razon={defrazon} token={deftoken} /> : page === "individual_links" ? <IndividualLinks rif={defrif} razon={defrazon} token={deftoken} nombre_usuario={defnombre} img={defimg} /> : <MasiveLinks rif={defrif} razon={defrazon} token={deftoken} nombre_usuario={defnombre} img={defimg} />} */}
          {page === "home" ? <Resume id_empresa={props.id_empresa} id_usuario={props.id_usuario} token={deftoken} id_commerce={defidCommerce}></Resume> : page === "charts" ? <Graph rif={defrif} razon={defrazon} token={deftoken} nombre_usuario={defnombre} img={defimg} id_usuario={props.id_usuario} id_commerce={defidCommerce} /> : page === "linkcobro" ? <LinksCobro rif={defrif} razon={defrazon} token={deftoken} nombre_usuario={nombreusuario} img={defimg} id_usuario={idusuario} id_commerce={defidCommerce}></LinksCobro> : page === "individual_links" ? <IndividualLinks rif={defrif} razon={defrazon} token={deftoken} nombre_usuario={defnombre} img={defimg} id_usuario={props.id_usuario} id_commerce={defidCommerce} /> : page === "txReports" ? <TxReports rif={defrif} razon={defrazon} token={deftoken} nombre_usuario={defnombre} img={defimg} id_usuario={props.id_usuario} id_commerce={defidCommerce} /> : <MasiveLinks rif={defrif} razon={defrazon} token={deftoken} nombre_usuario={defnombre} img={defimg} id_usuario={props.id_usuario} id_commerce={defidCommerce} />}
        </Paper>
      </Grid>

    </Grid>

  )
}

